module.exports = __webpack_public_path__ + "static/media/figure14.0ae4aa39.png";